import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 2,
  class: "iconOfEditInPageDetail iconOfEditInPageDetailNoOnClick"
}
const _hoisted_3 = {
  key: 3,
  class: "global-bottom-buttons"
}
const _hoisted_4 = { class: "car-tag-group" }
const _hoisted_5 = ["src", "title"]
const _hoisted_6 = { class: "autoListMultipleSelectWrap" }
const _hoisted_7 = {
  key: 0,
  class: "fl-row fl-wrap"
}
const _hoisted_8 = ["src", "title"]
const _hoisted_9 = {
  key: 2,
  class: "iconOfEditInPageDetail iconOfEditInPageDetailNoOnClick"
}
const _hoisted_10 = {
  key: 3,
  class: "global-bottom-buttons"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "一年", -1)
const _hoisted_12 = {
  key: 1,
  class: "iconOfEditInPageDetail iconOfEditInPageDetailNoOnClick"
}
const _hoisted_13 = {
  key: 2,
  class: "global-bottom-buttons"
}
const _hoisted_14 = {
  key: 2,
  class: "iconOfEditInPageDetail iconOfEditInPageDetailNoOnClick"
}
const _hoisted_15 = {
  key: 3,
  class: "global-bottom-buttons"
}
const _hoisted_16 = { class: "dialogWarp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_form_outlined = _resolveComponent("form-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    ref: "rootRef",
    class: "staffDetailDrawer",
    width: "620",
    title: _ctx.drawerTitle,
    placement: "right",
    closable: true,
    visible: _ctx.drawerVisible,
    "destroy-on-close": true,
    onClose: _ctx.fnDrawerClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: _ctx.dataLoading }, {
        default: _withCtx(() => [
          _createVNode(_component_app_section, { title: "基本信息" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_a_form, {
                ref: "refBaseForm",
                model: _ctx.basicFormData,
                rules: _ctx.rulesBaseInfo,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "姓名",
                    name: "userName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.basicFormData.userName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.basicFormData.userName) = $event)),
                        type: "text",
                        maxlength: 32,
                        "allow-clear": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "手机号码",
                    name: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.basicFormData.phone,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.basicFormData.phone) = $event)),
                        "max-length": 11,
                        disabled: "",
                        "allow-clear": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "工号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.basicFormData.jobNumber,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.basicFormData.jobNumber) = $event)),
                        maxlength: 32,
                        "allow-clear": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "部门" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tree_select, {
                        value: _ctx.basicFormData.departmentIds,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.basicFormData.departmentIds) = $event)),
                        style: {"width":"280px"},
                        "allow-clear": "",
                        "show-search": "",
                        multiple: "",
                        "search-placeholder": "请选择",
                        "show-line": true,
                        "filter-tree-node": _ctx.filterTreeNode,
                        "tree-data": _ctx.departmentList
                      }, null, 8, ["value", "filter-tree-node", "tree-data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "角色" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.basicFormData.roleId,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.basicFormData.roleId) = $event)),
                        placeholder: "请选择",
                        mode: "multiple",
                        disabled: _ctx.isAdministrator,
                        "filter-option": _ctx.rolefilterOption
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.roleId,
                              value: item.roleId,
                              disabled: item.initStatus === 'INIT' || item.roleName === '部门主管',
                              label: item.roleName
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.roleName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "disabled", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "disabled", "filter-option"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "员工状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.basicFormData.state,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.basicFormData.state) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 'ON' }, {
                            default: _withCtx(() => [
                              _createTextVNode("在职")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 'QUIT' }, {
                            default: _withCtx(() => [
                              _createTextVNode("离职")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  (_ctx.isScheduleModel)
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 0,
                        label: "油补报销"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio_group, {
                            value: _ctx.basicFormData.oilSupplementFlag,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.basicFormData.oilSupplementFlag) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("否")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_radio, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("是")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model", "rules", "label-col", "wrapper-col"]), [
                [_vShow, _ctx.isEditBaseInfo]
              ]),
              (!_ctx.isEditBaseInfo)
                ? (_openBlock(), _createBlock(_component_a_form, {
                    key: 0,
                    model: _ctx.basicFormData,
                    rules: _ctx.rulesBaseInfo,
                    "label-col": _ctx.labelCol,
                    "wrapper-col": _ctx.wrapperCol
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "姓名",
                        name: "name",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.basicFormData.userName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "手机号码",
                        name: "phone"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.basicFormData.phone), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "工号" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.basicFormData.jobNumber || '--'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "部门" }, {
                        default: _withCtx(() => [
                          (_ctx.basicFormData.departments && _ctx.basicFormData.departments.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.basicFormData.departments, (item) => {
                                return (_openBlock(), _createBlock(_component_a_tag, {
                                  key: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.departmentName), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : (_openBlock(), _createElementBlock("span", _hoisted_1, "无"))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "角色" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basicFormData.roleNames, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_tag, {
                              key: item + index,
                              color: "default"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "员工状态" }, {
                        default: _withCtx(() => [
                          (_ctx.basicFormData.state === 'ON')
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 0,
                                color: "green"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("在职")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_a_tag, {
                                key: 1,
                                color: "red"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("离职")
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      (_ctx.isScheduleModel)
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            label: "油补报销"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.basicFormData.oilSupplementFlag === 1)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 0,
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("否")
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("是")
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, { label: "加入时间" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.basicFormData.createDate ? _ctx.formatDate(new Date(_ctx.basicFormData.createDate).toString()) : ''), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
                : _createCommentVNode("", true),
              ((!_ctx.isEditBaseInfo && !_ctx.isEditAutoInfo && !_ctx.isEditRestInfo && !_ctx.isEditObdInfo))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "iconOfEditInPageDetail",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isEditBaseInfo = !_ctx.isEditBaseInfo))
                  }, [
                    _createVNode(_component_form_outlined)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditAutoInfo || _ctx.isEditRestInfo || _ctx.isEditObdInfo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_form_outlined)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditBaseInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editCancel('isEditBaseInfo' , false)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.onSubmitBasicInfo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_app_section, {
            title: "员工车辆",
            style: {"position":"relative"}
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_a_form, {
                model: _ctx.vehicleInfos,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol,
                rules: _ctx.rulesBaseInfo
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "绑定车辆" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choisedAutoListOnShow, (item) => {
                          return (_openBlock(), _createBlock(_component_a_tag, {
                            key: item.id,
                            closable: "",
                            class: "car-tag",
                            onClose: ($event: any) => (_ctx.closeAutoTag(item.id))
                          }, {
                            default: _withCtx(() => [
                              (item.vehicleBrandLogo)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.vehicleBrandLogo,
                                    width: "30",
                                    class: "listOnEmImg",
                                    title: item.vehicleBrandName,
                                    alt: "BrandLogo",
                                    style: {"border":"none"}
                                  }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true),
                              _createElementVNode("em", null, _toDisplayString(item.licensePlate || item.vin || ''), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClose"]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_select, {
                          value: _ctx.choisedAutoIds,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.choisedAutoIds) = $event)),
                          mode: "multiple",
                          placeholder: "请选择",
                          class: "autoListMultipleSelect",
                          "get-popup-container": _ctx.autoGetPopupContainer,
                          "filter-option": _ctx.onFilterAutoList
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedAutoList, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.id,
                                value: item.id,
                                disabled: item.state !== 'OPEN' || (_ctx.isScheduleModel && +item.num > 0)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.licensePlate || item.vin || ''), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "get-popup-container", "filter-option"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "可使用公车范围" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.usingCarType,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.usingCarType) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("无")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode("部门下所有公车")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("公司下所有公车")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "label-col", "wrapper-col", "rules"]), [
                [_vShow, _ctx.isEditAutoInfo]
              ]),
              (!_ctx.isEditAutoInfo)
                ? (_openBlock(), _createBlock(_component_a_form, {
                    key: 0,
                    model: _ctx.vehicleInfos,
                    "label-col": _ctx.labelCol,
                    "wrapper-col": _ctx.wrapperCol,
                    rules: _ctx.rulesBaseInfo
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "绑定车辆" }, {
                        default: _withCtx(() => [
                          (_ctx.choisedAutoListOnShow.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choisedAutoListOnShow, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    key: item.id,
                                    closable: _ctx.isEditAutoInfo,
                                    class: "car-tag",
                                    style: {"margin":"4px"},
                                    onClose: ($event: any) => (_ctx.closeAutoTag(item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      (item.vehicleBrandLogo)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: item.vehicleBrandLogo,
                                            width: "30",
                                            class: "listOnEmImg",
                                            alt: "BrandLogo",
                                            title: item.vehicleBrandName,
                                            style: {"border":"none"}
                                          }, null, 8, _hoisted_8))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("em", null, _toDisplayString(item.licensePlate || item.vin || ''), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["closable", "onClose"]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("无")
                              ], 64))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "可使用公车范围" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.usingCarType === 0 ? '公司下所有公车' : _ctx.usingCarType === 2 ? '部门下所有公车' : '无'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "label-col", "wrapper-col", "rules"]))
                : _createCommentVNode("", true),
              ((!_ctx.isEditBaseInfo && !_ctx.isEditAutoInfo && !_ctx.isEditRestInfo && !_ctx.isEditObdInfo))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "iconOfEditInPageDetail",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isEditAutoInfo = !_ctx.isEditAutoInfo))
                  }, [
                    _createVNode(_component_form_outlined)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditBaseInfo || _ctx.isEditRestInfo || _ctx.isEditObdInfo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(_component_form_outlined)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditAutoInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editCancel('isEditAutoInfo' , false)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.saveAutoInfoHandler
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.obdStatus)
            ? (_openBlock(), _createBlock(_component_app_section, {
                key: 0,
                title: "OBD管理",
                style: {"position":"relative"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, {
                    ref: "formRef",
                    model: _ctx.obdInfos,
                    "label-col": _ctx.labelCol,
                    "wrapper-col": _ctx.wrapperCol,
                    rules: _ctx.rulesObdInfo
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", null, [
                        _createVNode(_component_a_form_item, {
                          label: "OBD序列号",
                          name: "obdCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.obdInfos.obdCode,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.obdInfos.obdCode) = $event)),
                              maxlength: 20,
                              "allow-clear": ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "卡号",
                          name: "iccId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.obdInfos.iccId,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.obdInfos.iccId) = $event)),
                              placeholder: "请输入卡号",
                              "show-search": "",
                              "allow-clear": "",
                              "default-active-first-option": false,
                              "show-arrow": false,
                              "filter-option": false,
                              "not-found-content": null,
                              onSearch: _ctx.handleSearch
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iccIdList, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.iccId,
                                    value: item.iccId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.iccId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "onSearch"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "卡开通期限",
                          name: "openingPeriodDate"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_date_picker, {
                              value: _ctx.obdInfos.openingPeriodDate,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.obdInfos.openingPeriodDate) = $event)),
                              "allow-clear": false,
                              placeholder: "请选择卡开通期限"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_vShow, _ctx.isEditObdInfo]
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createVNode(_component_a_form_item, {
                          label: "OBD序列号",
                          name: "obdCode"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.obdInfos.obdCode || '--'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "卡号",
                          name: "iccId"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.obdInfos.iccId || '--'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "卡开通期限",
                          name: "openingPeriodDate"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.obdInfos.openingPeriodDate || '--'), 1)
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_vShow, !_ctx.isEditObdInfo]
                      ]),
                      _createVNode(_component_a_form_item, { label: "卡第一次启用时间" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.obdInfos.firstActivationTime || '暂未启用'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "卡实际计费开始时间" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.obdInfos.actualBillingStartTime || '暂未启用'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "卡流量有效时间" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "卡流量到期时间" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.obdInfos.expirationTime || '--'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "label-col", "wrapper-col", "rules"]),
                  ((!_ctx.isEditBaseInfo && !_ctx.isEditAutoInfo && !_ctx.isEditRestInfo && !_ctx.isEditObdInfo))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "iconOfEditInPageDetail",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isEditObdInfo = !_ctx.isEditObdInfo))
                      }, [
                        _createVNode(_component_form_outlined)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isEditBaseInfo || _ctx.isEditAutoInfo || _ctx.isEditRestInfo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createVNode(_component_form_outlined)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isEditObdInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_a_button, {
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editCancel('isEditObdInfo' , false)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _ctx.saveObdInfos
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("保存")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_app_section, {
            title: "员工制度",
            style: {"position":"relative"}
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_a_form, {
                model: _ctx.lineInfo,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "加油制度" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.restInfo.id,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.restInfo.id) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_a_select_option, {
                            key: 'v0',
                            value: 0
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("请选择")
                            ]),
                            _: 1
                          })),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restrictList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.confNo,
                              value: item.confNo
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "label-col", "wrapper-col"]), [
                [_vShow, _ctx.isEditRestInfo]
              ]),
              (!_ctx.isEditRestInfo)
                ? (_openBlock(), _createBlock(_component_a_form, {
                    key: 0,
                    model: _ctx.lineInfo,
                    "label-col": _ctx.labelCol,
                    "wrapper-col": _ctx.wrapperCol
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "加油制度" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.restInfo.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "label-col", "wrapper-col"]))
                : _createCommentVNode("", true),
              ((!_ctx.isEditBaseInfo && !_ctx.isEditAutoInfo && !_ctx.isEditRestInfo && !_ctx.isEditObdInfo))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "iconOfEditInPageDetail",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isEditRestInfo = !_ctx.isEditRestInfo))
                  }, [
                    _createVNode(_component_form_outlined)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditBaseInfo || _ctx.isEditAutoInfo || _ctx.isEditObdInfo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _createVNode(_component_form_outlined)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isEditRestInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.editCancel('isEditRestInfo' , false)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.funcSaveRestInfo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["spinning"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.isQuitFormVisible,
        class: "noneFooterBorder",
        width: 420,
        "destroy-on-close": true,
        onOk: _ctx.onQuitFormConfirm,
        onCancel: _ctx.onQuitFormCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h3", null, [
              _createElementVNode("span", null, [
                _createVNode(_component_QuestionCircleFilled, { style: {"color":"#faad14"} })
              ]),
              _createTextVNode(" 确认离职该员工? ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk", "onCancel"])
    ]),
    _: 1
  }, 8, ["title", "visible", "onClose"]))
}